import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTModalCard = _resolveComponent("KTModalCard")!
  const _component_KTTwoFactorAuthModal = _resolveComponent("KTTwoFactorAuthModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_KTModalCard, {
      title: "Two-factor Authentication",
      description: "Click on the below buttons to launch <br/>two-factor authentication setup example.",
      image: _ctx.getIllustrationsPath('4.png'),
      "button-text": "Enable Two-factor Authentication",
      "modal-id": "kt_modal_two_factor_authentication"
    }, null, 8, ["image"]),
    _createVNode(_component_KTTwoFactorAuthModal)
  ], 64))
}